import React from 'react'

const Description = ({ children }: { children: React.ReactNode }) => (
  <div className="font-inter font-normal text-[12px] leading-[17px] text-[#6C7788]">{children}</div>
)

export default Description
